import { Box, Typography, SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { useCurrency } from "../../../hooks/useCurrency";

type PriceDisplayBoxProps = {
  color: string;
  StartIcon: OverridableComponent<SvgIconTypeMap<{ fontSize?: string }, "svg">>;
  price: number | string | undefined;
  percentage?: number;
};

export const PriceDisplayBox = (props: PriceDisplayBoxProps) => {
  const { percentage, price, StartIcon, color } = props;
  const { formatCurrency } = useCurrency();
  return (
    <Box display="flex" alignItems="center" color={color} gap={0.5}>
      <StartIcon sx={{ margin: "2px 4px", width: "16px", height: "16px" }} />
      <Box display="flex" alignItems="end" gap={0.5}>
        <Typography variant="body1">
          {formatCurrency(Number(price) || 0)}
        </Typography>
        {!(percentage == 0 || percentage == undefined) && (
          <Typography variant="caption" color={color}>
            ({percentage}%)
          </Typography>
        )}
      </Box>
    </Box>
  );
};
